import {
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
  TemplateRef,
  ViewChild
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { IEquipamento } from 'src/app/interfaces';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthenticationService, EquipamentoService } from 'src/app/services';
import { Subscription } from 'rxjs';
import { IToken } from 'src/app/interfaces/token/IToken';

@Component({
  selector: 'app-modal-editar-equipamento-localizacao',
  templateUrl: './modal-editar-equipamento-localizacao.component.html',
  styleUrls: ['./modal-editar-equipamento-localizacao.component.scss']
})
export class ModalEditarEquipamentoLocalizacaoComponent implements OnInit, OnDestroy {
  @Output() updateEquipamentoLocalizacao = new EventEmitter<IEquipamento>();
  @ViewChild('ModalEditarEquipamentoLocalizacao')
  modalEditarEquipamentoLocalizacao: TemplateRef<any>;
  subscriptions$ = new Subscription();
  equipamentoEditar: IEquipamento;
  editForm: FormGroup;
  token: IToken = this.authenticationService.obterToken();

  constructor(
    private fb: FormBuilder,
    private equipamentoService: EquipamentoService,
    private modalService: NgbModal,
    private authenticationService: AuthenticationService
  ) {}

  ngOnInit(): void {
    this.editForm = this.fb.group({
      local: ['', [Validators.maxLength(100)]],
      numeroSerie: [''],
      contrato: ['']
    });
  }

  ngOnDestroy(): void {
    this.subscriptions$.unsubscribe();
  }

  editarEquipamentoLocalizacao() {
    this.subscriptions$.add(
      this.equipamentoService
        .postAlterarLocalizacao({
          local: this.editForm.get('local')?.value,
          numeroSerie: this.editForm.get('numeroSerie')?.value,
          contrato: this.editForm.get('contrato')?.value
        })
        .subscribe({
          complete: () => {
            this.equipamentoEditar.local = this.editForm.get('local')?.value;

            this.updateEquipamentoLocalizacao.emit(this.equipamentoEditar);
            this.fecharModal();
          }
        })
    );
  }

  setForm(equipamento: IEquipamento) {
    this.editForm.setValue({
      local: equipamento.local,
      numeroSerie: equipamento.numSerie,
      contrato: equipamento.codigoContr
    });
    this.equipamentoEditar = equipamento;
  }

  abrirModal(equipamento: IEquipamento) {
    this.ngOnInit();
    this.modalService.open(this.modalEditarEquipamentoLocalizacao, {
      centered: true,
      size: 'lg'
    });
    this.setForm(equipamento);
  }

  fecharModal() {
    this.modalService.dismissAll();
  }

  isButtonEnabled() {
    return (
      this.editForm.getRawValue().local === this.equipamentoEditar.local &&
      this.editForm.getRawValue().numeroSerie === this.equipamentoEditar.numSerie &&
      this.editForm.getRawValue().contrato === this.equipamentoEditar.codigoContr
    );
  }
}
